import React,{Fragment} from 'react'
import {Routes , Route} from 'react-router-dom';
import MainNavigation from './Components/MainNavigation/MainNavigation';

import AllQuotes from './Components/Pages/AllQuotes';
import NewQuotes from './Components/Pages/NewQuotes';
import ShowQuote from './Components/Pages/ShowQuote';
import EditQuote from './Components/Pages/EditQuote';


const App = () => {
  return (
    // ?? fragments se div ke andar div nhi bante
    <Fragment>
      <MainNavigation/>
      <main>
        <Routes>
          <Route path='/' element={<AllQuotes/>} />
          <Route path='/new' element={<NewQuotes/>} />
          <Route path="/quotes/:id" element={<ShowQuote/>}/>
          <Route path="/quotes/edit/:id" element={<EditQuote/> }/>
        </Routes>
      </main>
    </Fragment>
  )
}

export default App